module.exports = __webpack_public_path__ + "img/flowers-8013886_1280.23b60100.png";